var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 509,
    height: 345.761,
    viewBox: "0 0 509 345.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_13915",
    x: 0,
    y: 248.29,
    width: 388.463,
    height: 97.471,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#183c77"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_13913",
    x: 39.251,
    y: 179.457,
    width: 307.526,
    height: 92.352,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#183c77"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_13914",
    x: 78.683,
    y: 107.376,
    width: 227.533,
    height: 94.348,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#183c77"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_13916",
    x: 119.243,
    y: 0,
    width: 147.54,
    height: 129.642,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#183c77"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15074",
    "data-name": "Grupo 15074",
    transform: "translate(-732 -3680.851)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 732, 3680.85)",
    filter: "url(#Caminho_13915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13915-2",
    "data-name": "Caminho 13915",
    d: "M282.573,266.409l35.943,61.471H-33.948L.529,266.409Z",
    transform: "translate(51.95 -5.12)",
    fill: "#0065c9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 732, 3680.85)",
    filter: "url(#Caminho_13913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13913-2",
    "data-name": "Caminho 13913",
    d: "M252.967,266.551,284.912,322.9H13.385L45.7,266.551Z",
    transform: "translate(43.87 -74.09)",
    fill: "#218cf5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 732, 3680.85)",
    filter: "url(#Caminho_13914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13914-2",
    "data-name": "Caminho 13914",
    d: "M297.021,296.823l33.844,58.348H139.331l33.844-58.348Z",
    transform: "translate(-42.65 -176.45)",
    fill: "#4492e1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 732, 3680.85)",
    filter: "url(#Caminho_13916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13916-2",
    "data-name": "Caminho 13916",
    d: "M177.725,270.767l55.815,93.642H122l55.725-93.642Z",
    transform: "translate(15.24 -257.77)",
    fill: "#6bacde"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SOC_Manager",
    "data-name": "SOC Manager",
    transform: "translate(878.616 3735.799)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30,
    y: 17
  }, "SOC "), /*#__PURE__*/React.createElement("tspan", {
    x: 13,
    y: 36
  }, "Manager")), /*#__PURE__*/React.createElement("text", {
    id: "Tier_3",
    "data-name": "Tier 3",
    transform: "translate(874 3819.555)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30,
    y: 17
  }, "Tier 3")), /*#__PURE__*/React.createElement("text", {
    id: "Tier_2",
    "data-name": "Tier 2",
    transform: "translate(876.6 3889.826)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30,
    y: 17
  }, "Tier 2")), /*#__PURE__*/React.createElement("text", {
    id: "Tier_1",
    "data-name": "Tier 1",
    transform: "translate(883.147 3962.459)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 23,
    y: 17
  }, "Tier 1")), /*#__PURE__*/React.createElement("line", {
    id: "Linha_279",
    "data-name": "Linha 279",
    x2: 450.5,
    transform: "translate(789.5 3929.66)",
    fill: "none",
    stroke: "#009bde",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_280",
    "data-name": "Linha 280",
    x2: 422.39,
    transform: "translate(817.61 3859.459)",
    fill: "none",
    stroke: "#009bde",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_281",
    "data-name": "Linha 281",
    x2: 385,
    transform: "translate(855 3787.493)",
    fill: "none",
    stroke: "#009bde",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_282",
    "data-name": "Linha 282",
    x2: 490,
    transform: "translate(750 4003.611)",
    fill: "none",
    stroke: "#009bde",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "Triagem_Notifica\\xE7\\xE3o_Escalagem",
    "data-name": "Triagem; Notifica\\xE7\\xE3o; Escalagem",
    transform: "translate(1108 3953.804)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Triagem; Notifica\xE7\xE3o; "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 37
  }, "Escalagem")), /*#__PURE__*/React.createElement("text", {
    id: "Resposta_a_incidentes_monitoriza\\xE7\\xE3o",
    "data-name": "Resposta a incidentes;  monitoriza\\xE7\\xE3o",
    transform: "translate(1074 3882.903)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15,
    xmlSpace: "preserve"
  }, "Resposta a incidentes;  "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 37
  }, "monitoriza\xE7\xE3o")), /*#__PURE__*/React.createElement("text", {
    id: "An\\xE1lise_forense_Resposta_ao_Incidente_",
    "data-name": "An\\xE1lise forense; Resposta ao Incidente ",
    transform: "translate(1026 3807.585)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "An\xE1lise forense; Resposta ao "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 37
  }, "Incidente ")), /*#__PURE__*/React.createElement("text", {
    id: "Respons\\xE1vel_pela_organiza\\xE7\\xE3o_da_equipa",
    "data-name": "Respons\\xE1vel pela organiza\\xE7\\xE3o da equipa",
    transform: "translate(994.145 3737.21)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Respons\xE1vel pela organiza\xE7\xE3o "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 37
  }, "da equipa")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiear);
export default __webpack_public_path__ + "static/media/tiear.fef06457eab1b3851b606175b485dfe4.svg";
export { ForwardRef as ReactComponent };